import { render, staticRenderFns } from "./quotations-income.vue?vue&type=template&id=4e0f7219"
import script from "./quotations-income.vue?vue&type=script&lang=js"
export * from "./quotations-income.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports